import { defineStore } from "pinia";

export const useLocationStore = defineStore("location", {
  state: () => ({
    selectedStore: null,
    showStoreModal: false
  }),

  actions: {
  setStore(store) {
  const rawId = String(store.id); // 🔑 NORMALIZAMOS

  this.selectedStore = {
    id: rawId.startsWith("gid://")
      ? rawId
      : `gid://shopify/Location/${rawId}`,
    name: store.name
  };

  localStorage.setItem(
    "selectedStore",
    JSON.stringify(this.selectedStore)
  );

  this.showStoreModal = false;
}



    ,

    openModal() {
      this.showStoreModal = true;
    },

    loadFromStorage() {
      const saved = localStorage.getItem("selectedStore");
      if (saved) {
        this.selectedStore = JSON.parse(saved);
      }
    }
  }
});
